import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"


const Head = ({ title }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Helmet title={`${title} | ${data.site.siteMetadata.title}`}>
      <link rel="stylesheet" type="text/css" href="./lightbox.min.css"></link>
      <script src="./vendor/lightbox-plus-jquery.min.js"></script>
    </Helmet>
  )
}

export default Head
